import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateTime } from "luxon";
import { DateHelper } from "../../../../Common/DateHelper";
import { Status } from "../../../../Components/Miscellaneous/BookingStatus/BookingStatus";

export class Task extends ODataSelect
{
    public Node_Id = 0;
    public Booking_Id = "";
    public Task_Id = 0;
    public Task_Type_Name = "";
    public CreatedAt = "";
    public Task_Category_Name = "";
    public Space_Id = "";
    public Task_Priority = 0;
    public Task_Due_Date = DateHelper.null();;
    public Task_Owner = "";
    public Task_Event_Time = DateHelper.null();
    public Task_CreatedBy = "";
    public Task_Status = "";
    public Task_IsActive = 0;
    public Task_IsOwned = 0;
    public Task_TTC = 0;

    public init(response: any, nodeId: number): Task
    {
        super.init(response, nodeId);
        this.Task_Event_Time = DateHelper.fromIsoByNode(response.Task_Event_Time, nodeId);
        this.Task_Due_Date = DateHelper.fromIsoByNode(response.Task_Due_Date, nodeId);
        return this;
    }

}

export interface ITasksFilter
{
    status?: string;
    owner?: string;
    taskCategory?: "Catering";
    taskStatusNot?: string[];
    createdBy?: string;
    createdFrom?: DateTime;
    createdTo?: DateTime;
    taskEventStart?: DateTime;
    taskEventEnd?: DateTime;
    taskDueFrom?: DateTime;
    taskDueTo?: DateTime;
}

export interface ITaskPriorityChange
{
    Task_Priority: string;
}

export interface ITaskView 
{
    id: number;
    Task_Type_Name: string;
    Task_Category_Name: string;
    spaceNames: string[];
    Task_Priority: number;
    Task_Due_Date: string;
    Task_TTC: number;
    timeZone?: string;
    Task_CreatedBy: string;
    Task_Owner: string;
    Task_Status: Status;
    CreatedAt: string;
    Node_Id: number;
    Task_Id: number;
}